import { Carousel } from "react-bootstrap";
import deportesImg from "../../../assets/images/36.jpg";
import imgHockey from "../../../assets/images/35.jpg";
import imgRugby from "../../../assets/images/41deportes.jpg";
import imgAtletismo from "../../../assets/images/42deportes.jpg";
import imgAtletismo1 from "../../../assets/images/43deportes.jpg";
import imgAtletismo2 from "../../../assets/images/44deportes.jpg";
import imgAtletismo3 from "../../../assets/images/45deportes.jpg";

function Deportes() {
  return (
    <div className="container text-center mt-5">
      {/* Título */}
      <h2 className="text-primary fw-bold">🏆 Departamento de Deportes</h2>

      <div className="row mt-4">
        {/* Imagen a la izquierda */}
        <div className="col-md-5">
          <img src={deportesImg} alt="Deportes Colegio Santo Tomás" className="img-fluid rounded shadow" />
        </div>

        {/* Contenido a la derecha */}
        <div className="col-md-7 text-justify mx-auto" style={{ textAlign: "justify" }}>
          <p>
            En el <strong>Departamento de Deportes</strong> del Colegio Santo Tomás, consideramos la actividad física como un pilar 
            fundamental en la formación integral de nuestros estudiantes. Nuestro principal objetivo es que el deporte se 
            convierta en una herramienta para el desarrollo personal en un entorno de disciplina y contención.
          </p>
          <p>
            Valoramos la importancia de educar a nuestros alumnos en <strong>hábitos de vida saludables</strong>, promoviendo el respeto 
            mutuo, el trabajo en equipo, el esfuerzo constante y la superación personal.
          </p>
          
          {/* Lista de deportes */}
          <h4 className="text-success fw-bold mt-3">⚽ Deportes que ofrecemos:</h4>
          <ul className="list-unstyled">
            <li>🏒 <strong>Hockey</strong></li>
            <li>🏉 <strong>Rugby</strong></li>
            <li>🏃‍♂️ <strong>Atletismo</strong></li>
          </ul>

          {/* Intercambios deportivos */}
          <p>
            Además, los deportes no solo fortalecen el cuerpo, sino que también brindan la oportunidad de conocer y 
            apreciar otras culturas y valores, especialmente a través de los <strong>intercambios deportivos</strong> que organizamos.
          </p>
        </div>
      </div>

      {/* Galería de imágenes */}
      <div className="mt-5">
        <h3 className="text-primary fw-bold">📸 Nuestra Galería Deportiva</h3>
        <Carousel className="mx-auto" style={{ maxWidth: "800px" }} interval={3000}>
          <Carousel.Item>
            <img className="d-block w-100 rounded" src={imgHockey} alt="Hockey" />
          </Carousel.Item>
          <Carousel.Item>
            <img className="d-block w-100 rounded" src={imgRugby} alt="Rugby" />
          </Carousel.Item>
          <Carousel.Item>
            <img className="d-block w-100 rounded" src={imgAtletismo} alt="Atletismo" />
          </Carousel.Item>
          <Carousel.Item>
            <img className="d-block w-100 rounded" src={imgAtletismo1} alt="Atletismo" />
          </Carousel.Item>
          <Carousel.Item>
            <img className="d-block w-100 rounded" src={imgAtletismo2} alt="Atletismo" />
          </Carousel.Item>
          <Carousel.Item>
            <img className="d-block w-100 rounded" src={imgAtletismo3} alt="Atletismo" />
          </Carousel.Item>
        </Carousel>
      </div>
    </div>
  );
}

export default Deportes;
